export default "__VITE_ASSET__df90658f__";